type Props = Array<string>;

export const defaultFinancialAccounts: Props = [
  "account payable",
  "salary account",
  "account receivable",
];

export const defaultTypeAccounts: Props = ["Control Account", "Bank Account"];

export const defaultEntriesCategories: Props = [
  "salary",
  "light and water",
  "internet",
  "phone",
  "receipts",
  "sale",
  "schedule-procedures",
  "water",
  "sales",
  "light",
];

export const defaultRole: Props = ["admin", "secretary", "accountant"];
